import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PROJECTS } from "@/data/content";

const FEATURED = PROJECTS.slice(0, 3);

const WorkCard = ({ project }) => (
    <Link to="/works" data-testid={`featured-card-${project.id}`} className="group block">
        <div className="relative">
            <div className="absolute -inset-0 translate-x-2.5 translate-y-2.5 border border-wood/15 transition-transform duration-500 group-hover:translate-x-1 group-hover:translate-y-1" />
            <div className="relative overflow-hidden">
                <img
                    src={project.src}
                    alt={project.title}
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
            </div>
        </div>
        <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-terra">
            {project.category} — {project.location}
        </p>
        <h3 className="mt-2 font-serif text-xl font-medium text-ink transition-colors duration-300 group-hover:text-terra">{project.title}</h3>
    </Link>
);

const FeaturedHeader = () => (
    <div className="flex flex-wrap items-end justify-between gap-8">
        <div>
            <div className="flex items-center gap-4">
                <span className="font-mono text-sm text-terra">02</span>
                <span className="h-px w-10 bg-terra/50" />
                <span className="text-xs uppercase tracking-[0.25em] text-timber">Selected Works</span>
            </div>
            <h2 className="mt-6 font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
                Spaces, Conceived Together
            </h2>
        </div>
        <Link to="/works" data-testid="home-works-link" className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-wood transition-colors hover:text-terra">
            View all works
            <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
    </div>
);

export const FeaturedWorks = () => (
    <section data-testid="home-featured-works" className="relative bg-sand py-20 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
            <Reveal>
                <FeaturedHeader />
            </Reveal>
            <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3 lg:gap-8">
                {FEATURED.map((p, i) => (
                    <Reveal key={p.id} delay={0.08 * i} className={i === 1 ? "md:mt-12" : ""}>
                        <WorkCard project={p} />
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
